import { Record } from 'immutable';

const EventSortRecord = Record({
  sortField: null,
  sortDirection: null
});

export class EventSort extends EventSortRecord {
  sortField: string;
  sortDirection: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-sort.ts